"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbolOf = void 0;
var isEmpty_1 = __importDefault(require("lodash/fp/isEmpty"));
var prop_1 = __importDefault(require("lodash/fp/prop"));
var compose_1 = __importDefault(require("lodash/fp/compose"));
var find_1 = __importDefault(require("lodash/fp/find"));
var eq_1 = __importDefault(require("lodash/fp/eq"));
var utils_1 = require("./utils");
var NumberFormat = Intl.NumberFormat;
/**
 * @example
 * ```typescript
 * SymbolOf('USD', 'en_US') // $
 * SymbolOf('USD', 'zh-CN') // US$
 * SymbolOf('USD', '')    // USD
 *
 * SymbolOf('', 'en-US')  // ''
 * SymbolOf('', '')       // ''
 * ```
 * */
var symbolOf = function (code, locale) {
    if ((0, isEmpty_1.default)(code) || (0, isEmpty_1.default)(locale)) {
        return code.toUpperCase();
    }
    return (0, compose_1.default)((0, prop_1.default)('value'), (0, find_1.default)((0, compose_1.default)((0, eq_1.default)('currency'), (0, prop_1.default)('type'))))(NumberFormat((0, utils_1.parseLocale)(locale), {
        style: 'currency',
        currency: code,
    }).formatToParts());
};
exports.symbolOf = symbolOf;
